<h1 mat-dialog-title>Add New ICAO for 1200.aero</h1>
<div mat-dialog-content>
    <mat-form-field class="w-100">
        <input matInput [(ngModel)]="icaosInput" placeholder="Airport" (keyup.enter)="onSaveClick()">
    </mat-form-field>
</div>
<div class="mt-2 text-center">
    <button
        (click)="onSaveClick()"
        [disabled]="!icaosInput.trim()"
        class="mr-1"
        color="accent"
        mat-flat-button
    >
        Add New
    </button>
    <button (click)="onCancelClick()" mat-stroked-button>Cancel</button>
</div>
